class Menu {
    constructor() {
        this.DOM = {
            body: document.body,
            MenuButton: document.querySelector('.menu-button'),
            MenuBackdrop: document.querySelector('.site-header-scrolled-backdrop'),
            HeaderScrolledDropdownItems: document.querySelectorAll(
                '.site-header-scrolled .menu .menu-item-has-children > a'
            )
        };

        this.setEventListeners();
    }

    setEventListeners() {
        if (this.DOM.MenuButton) {
            this.DOM.MenuButton.addEventListener('click', () => this.toggleMenu());
        }

        if (this.DOM.MenuBackdrop) {
            this.DOM.MenuBackdrop.addEventListener('click', () => this.toggleMenu(false));
        }

        this.DOM.HeaderScrolledDropdownItems.forEach((menuItem) => {
            menuItem.addEventListener('click', (e) => this.toggleSubMenu(e, menuItem));
        });
    }

    toggleMenu(force) {
        this.DOM.body.classList.toggle('menu-open', force);
        if (this.DOM.body.classList.contains('menu-open') && window.scrollObject.scrollSmoother) {
            window.scrollObject.scrollSmoother.stop();
        } else if (window.scrollObject.scrollSmoother) {
            window.scrollObject.scrollSmoother.start();
        }
    }

    toggleSubMenu(e, currentMenuItem) {
        let parentMenuItem = currentMenuItem.parentElement;
        let arrow = currentMenuItem.querySelector('.dropdown-arrow');
        let target = e.target;
        const currentIsOpen = Boolean(parentMenuItem.classList.contains('submenu-open'));

        if (!currentIsOpen || target === arrow) {
            e.preventDefault();
        }

        let alreadyOpened = false;
        this.DOM.HeaderScrolledDropdownItems.forEach((subMenuItem) => {
            const isOpen = Boolean(subMenuItem.parentElement.classList.contains('submenu-open'));
            if (isOpen) {
                subMenuItem.parentElement.classList.remove('submenu-open');
                alreadyOpened = true;
            }
        });

        // document.body.classList.toggle('mobile-submenu-open', !currentIsOpen);

        setTimeout(
            () => {
                if (!currentIsOpen) {
                    parentMenuItem.classList.add('submenu-open');
                }
            },
            alreadyOpened ? 500 : 0
        );
    }
}
window.Menu = new Menu();
